export default __webpack_public_path__ + "static/media/dfinity-earth-day.6ac0770c.jpg";